import { AbstractControl, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export function rawValueChanges<TControl extends { [K in keyof TControl]: AbstractControl<any> }>(
  fc: FormGroup<TControl>
): Observable<ReturnType<(typeof fc)['getRawValue']>> {
  return fc.valueChanges.pipe(map(() => fc.getRawValue()));
}
